module.exports = __webpack_public_path__ + "static/viread-illustrations-4-96fbc65668000dce27e2b6e4b922cc5a.jpg";